/* RSI Lead Confirm Modal — 2026-09-09. Post-submit "we've received your
   enquiry" popup for the installation, sell-your-racking and get-a-quote
   forms. Never touches those forms' own submission/validation/webhook
   logic (assets/rsi-lead-form-upload.js, or the plain native submit on
   sections/rsi-get-a-quote.liquid) — only adds an extra 'submit' LISTENER
   (not a handler replacement) that stashes which form is about to submit,
   plus reads a server-evaluated success marker on the next page load.

   One instance of [data-rsi-lcm] exists at most per page (each of the
   three sections renders its own). Multiple can technically coexist if a
   theme editor ever adds more than one to the same page — everything
   below is written per-instance so that's harmless, it would just mean
   two independent modals each watching their own form id. */
(function () {
  'use strict';

  if (window.__rsiLcmInit) return;
  window.__rsiLcmInit = true;

  var PENDING_KEY = 'rsi_lcm_pending_submission';
  var REASON_KEY = 'rsi_lcm_pending_reason';
  var PENDING_MAX_AGE_MS = 5 * 60 * 1000;

  // ---- Microsoft Ads (UET) conversion signal, installation enquiries only ----
  // 2026-10-05. The UET tag (187275947) does NOT run in this page: Shopify
  // loads it inside a web-pixel sandbox iframe, so window.uetq is undefined in
  // the theme's own window and pushing to it from here would silently create a
  // throwaway array that nothing ever reads. The supported bridge is to publish
  // a Shopify analytics custom event from the page; a custom pixel subscribes to
  // it inside the sandbox and forwards it to uetq. Consent is handled by Shopify
  // on the pixel side, so nothing here needs to re-check it.
  //
  // Keyed on the exact form id rather than the modal's "context", so an event
  // can only ever describe the one form it is named for. A form id that is not
  // listed publishes nothing at all.
  //
  // The custom pixel "Microsoft Ads - RISI UET" subscribes to these exact names
  // and forwards each to uetq as the matching UET event action.
  var LEAD_EVENTS = {
    'rsi-install-enquiry-form': 'risi_installation_quote_submitted',
    'rsi-we-buy-form-top': 'risi_sell_racking_enquiry_submitted',
    'rsi-quote-contact-form': 'risi_general_quote_submitted'
  };

  // Shared with assets/rsi-lead-form-upload.js and
  // assets/rsi-used-racking-quote-builder.js, so one successful submission can
  // never publish the same event twice even if two of those scripts run on the
  // same page. Per page load, which is the right scope: the native path reloads.
  window.__rsiLeadUetFired = window.__rsiLeadUetFired || {};

  function fireLeadConversion(formId, source) {
    var eventName = LEAD_EVENTS[formId];
    if (!eventName) return;
    if (window.__rsiLeadUetFired[eventName]) return;
    window.__rsiLeadUetFired[eventName] = true;
    try {
      window.Shopify.analytics.publish(eventName, { form_id: formId, source: source });
    } catch (e) { /* analytics unavailable — tracking is never allowed to break the form */ }
  }

  var COPY = {
    installation: {
      heading: 'Installation enquiry received',
      generic: "Thanks — we've received your installation enquiry. Our installation team will review your details and be in touch shortly.",
      withReason: function (reason) {
        return "Thanks — we've received your enquiry about " + reason + ". Our installation team will review your details and be in touch shortly.";
      }
    },
    sell: {
      heading: 'Enquiry received',
      generic: "Thanks — we've received your enquiry. Our buying team will review your details and be in touch shortly.",
      withReason: function (reason) {
        return "Thanks — we've received your enquiry about selling your " + reason + ". Our buying team will review your details and be in touch shortly.";
      }
    },
    quote: {
      heading: 'Quote request received',
      generic: "Thanks — we've received your enquiry. Our team will review your details and be in touch with a quote shortly.",
      withReason: function (reason) {
        return "Thanks — we've received your enquiry about " + reason + ". Our team will review your details and be in touch with a quote shortly.";
      }
    }
  };

  // Reasons too generic/negative to read naturally in a sentence — falls
  // back to the plain generic message instead ("...about Other." reads
  // like a mistake, not a confirmation).
  var VAGUE_REASON = /not sure|^other$/i;

  document.querySelectorAll('[data-rsi-lcm]').forEach(setupModal);

  function setupModal(root) {
    var context = root.getAttribute('data-rsi-lcm-context') || 'quote';
    var formId = root.getAttribute('data-rsi-lcm-form-id') || '';
    var reasonFieldName = root.getAttribute('data-rsi-lcm-reason-field') || '';
    var postedValue = root.getAttribute('data-rsi-lcm-posted') || '';
    var copy = COPY[context] || COPY.quote;

    var panel = root.querySelector('[data-rsi-lcm-panel]');
    var headingEl = root.querySelector('[data-rsi-lcm-heading]');
    var messageEl = root.querySelector('[data-rsi-lcm-message]');
    var liveEl = root.querySelector('[data-rsi-lcm-live]');
    var closeBtn = root.querySelector('.rsi-lcm__close');
    var opener = null;
    var keyHandler = function (evt) {
      if (evt.key === 'Escape') close();
    };

    function announce(text) {
      if (liveEl) liveEl.textContent = text;
    }

    function lockScroll() {
      root.scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = (-root.scrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      var y = root.scrollY || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, y);
    }

    function open(message) {
      if (headingEl) headingEl.textContent = copy.heading;
      if (messageEl && message) messageEl.textContent = message;
      opener = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
      if (window.trapFocus) window.trapFocus(root, closeBtn);
      root.addEventListener('keyup', keyHandler);
      announce(copy.heading);
    }

    function close() {
      if (root.hidden) return;
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      unlockScroll();
      root.removeEventListener('keyup', keyHandler);
      if (window.removeTrapFocus) window.removeTrapFocus(opener && document.contains(opener) ? opener : null);
    }

    root.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-rsi-lcm-close]')) close();
    });

    // ---- Redirect-detection: resume after this exact form's own submit ----
    // See snippets/rsi-lead-confirm-modal.liquid for why "postedValue"
    // alone isn't enough (Shopify's success flag is global per site, not
    // per form id) — PENDING_KEY, stashed immediately before the real
    // submit below, proves it was THIS form specifically.
    try {
      var pendingRaw = window.sessionStorage.getItem(PENDING_KEY);
      if (pendingRaw) {
        var pending = JSON.parse(pendingRaw);
        var fresh = pending && typeof pending.ts === 'number' && (Date.now() - pending.ts) < PENDING_MAX_AGE_MS;
        if (fresh && pending.formId === formId) {
          window.sessionStorage.removeItem(PENDING_KEY);
          if (postedValue === 'true') {
            var reason = '';
            try { reason = window.sessionStorage.getItem(REASON_KEY) || ''; } catch (e) {}
            try { window.sessionStorage.removeItem(REASON_KEY); } catch (e) {}
            var message = (reason && !VAGUE_REASON.test(reason)) ? copy.withReason(reason) : copy.generic;
            // Native Shopify /contact POST. Everything above has already proved
            // this exact form succeeded: a server-evaluated posted_successfully?
            // AND a fresh sessionStorage marker stashed by THIS form's own
            // submit. The marker is deleted on the line above, so a reload, a
            // bookmarked ?contact_posted=true URL, or another contact form's
            // success can none of them reach this point. Unlisted form ids
            // publish nothing.
            fireLeadConversion(formId, 'native');
            open(message);
          }
          // postedValue === 'false' (a real server-side rejection): leave
          // this alone entirely — each form already has its own inline
          // error handling (rsi-install-form__error / rsi-wb-top-error /
          // rsi-quote-form's per-field errors), which is the more useful
          // place to see what went wrong than a generic popup would be.
        }
      }
    } catch (e) { /* sessionStorage unavailable — enhancement only, skip */ }

    // ---- Arm the real form: stash which form + its "reason" value right
    // before it submits. A plain extra 'submit' listener (not a
    // replacement) — never calls preventDefault, so the existing
    // validation/webhook/native-submit handler on this exact form runs
    // completely unaffected, in the same order it already does. ----
    var realForm = document.getElementById(formId);
    if (!realForm) return;
    realForm.addEventListener('submit', function () {
      try {
        window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({ formId: formId, ts: Date.now() }));
        if (reasonFieldName) {
          // Plain quoted attribute-selector string — [ ] in the field
          // name (e.g. "contact[service]") are just literal characters
          // inside the quotes, nothing here needs CSS-identifier escaping.
          var field = realForm.querySelector('[name="' + reasonFieldName + '"]');
          var value = fieldDisplayValue(field);
          if (value) window.sessionStorage.setItem(REASON_KEY, value);
          else window.sessionStorage.removeItem(REASON_KEY);
        }
      } catch (e) { /* non-fatal — modal simply won't appear on this attempt */ }
    });

    function fieldDisplayValue(field) {
      if (!field) return '';
      if (field.tagName === 'SELECT') {
        var opt = field.options[field.selectedIndex];
        return opt ? opt.text.trim() : '';
      }
      return (field.value || '').trim();
    }
  }
})();
